export  const moneyPyramid = [
  { id: 1, amount: '£50' },
  { id: 2, amount: '£100' },
  { id: 3, amount: '£150' },
  { id: 4, amount: '£200' },
  { id: 5, amount: '£250' },
  { id: 6, amount: '£500' },
  { id: 7, amount: '£1000' },
  { id: 8, amount: '£1500' },
  { id: 9, amount: '£2000' },
  { id: 10, amount: '£2500' },
  { id: 11, amount: '£5000' },
  { id: 12, amount: '£10,000' },
  { id: 13, amount: '£20,000' },
  { id: 14, amount: '£50,000' },
  { id: 15, amount: '£100,000' },
].reverse();
